import FilesDataTable from "../../../components/dataTable/tables/FilesDataTable";

function FilesPageView() {
    return <FilesDataTable />;
}

export default FilesPageView;